import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import api from "../lib/api";

export default function Replay() {
  const { sessionId } = useParams();
  const [session, setSession] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/live/${sessionId}`);
        setSession(data);
      } catch (e) {
        setErr("Replay not found");
      }
    })();
  }, [sessionId]);

  if (err) return <div className="min-h-[100dvh] bg-ink flex items-center justify-center text-cream/50 text-sm">{err}</div>;
  if (!session) return <div className="min-h-[100dvh] bg-ink flex items-center justify-center text-cream/50 text-xs tracking-[0.3em] uppercase animate-pulse">Loading…</div>;

  return (
    <div className="min-h-[100dvh] bg-ink pb-32" data-testid="replay-page">
      <div className="px-5 pt-6 flex items-center gap-3">
        <Link to="/live" className="w-10 h-10 rounded-full crystal-glass flex items-center justify-center text-cream" data-testid="replay-back">
          <ArrowLeft size={18} />
        </Link>
        <div className="flex-1 min-w-0">
          <p className="text-papaya text-[10px] tracking-[0.3em] uppercase font-bold">Replay</p>
          <h1 className="text-cream text-xl font-black truncate">{session.title}</h1>
          <p className="text-cream/60 text-xs">@{session.host_username}</p>
        </div>
      </div>

      <div className="mt-6 px-2">
        {session.recording_url ? (
          <video
            src={session.recording_url}
            controls
            playsInline
            className="w-full aspect-video rounded-3xl bg-black"
            data-testid="replay-video"
          />
        ) : (
          <div className="aspect-video rounded-3xl bg-white/5 flex items-center justify-center text-cream/50 text-sm">
            Recording is still processing — check back in a few minutes.
          </div>
        )}
      </div>
    </div>
  );
}
